import React, { useRef } from 'react';
import './LiliFloatingLabel.css';
import { ReactComponent as ErrorIcon } from '../../assets/icons/svg/shared/ic-shared-error.svg';
import { ReactComponent as ClearIcon } from '../../assets/icons/svg/shared/ic-shared-clear.svg';

interface LiliFloatingLabelProps {
  children: React.ReactNode;
  errorMessage?: string;
  label: string;
  onClear?: () => void;
  inilineChild?: React.ReactNode;
  isOnclearButtonVisible?: boolean;
  disabled?: boolean;
}

export const LiliFloatingLabel = (props: LiliFloatingLabelProps) => {
  const { disabled, children, errorMessage, label, onClear, inilineChild, isOnclearButtonVisible } = props;

  const elBtnWrapper = useRef<HTMLButtonElement | null>(null);

  const handleInputWrapperClick = () => {
    const refElement: HTMLInputElement | null | undefined = elBtnWrapper.current?.querySelector('input');
    if (refElement) {
      refElement.focus();
    }
  };

  const handleClear = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation();
    if (onClear) {
      onClear();
    }
  };

  return (
    <div className='flex flex-col h-fit gap-[4px]'>
      <div className={`relative w-full h-[54px] px-[16px] rounded-[8px] border border-bw04 ${disabled ? '!bg-bw02' : ''}`}>
        <button
          ref={elBtnWrapper}
          id='LiliFloatingWrapper'
          type='button'
          onClick={handleInputWrapperClick}
          className='absolute inset-0 w-full h-full'
        />
        <div id='LiliFloatinginputWrapper' className='absolute w-[calc(100%-32px)] bottom-[8px]'>
          {children}
        </div>
        <p
          id='floatingLabel'
          className='pointer-events-none absolute transform ease-out duration-200 top-1/2 -translate-y-1/2 font-metricR text-[16px] text-bw06'
        >
          {label}
        </p>
        {onClear && isOnclearButtonVisible && (
          <button
            id='ClearInput'
            className='w-fit hidden absolute top-1/2 z-10 -translate-y-1/2 right-[16px]'
            type='button'
            onClick={handleClear}
          >
            <ClearIcon />
          </button>
        )}
      </div>
      <div className='flex flex-row justify-between '>
        <div id='ErrorContainer' className={`flex items-top gap-[4px] ${errorMessage ? 'visible' : 'invisible'}]`}>
          <ErrorIcon
            className={`max-w-[14px] max-h-[14px] min-w-[14px] min-h-[14px] mt-[4px]  ${errorMessage ? 'visible' : 'invisible'}`}
          />
          <p className={`font-metricRMedium text-[14px] text-red02  ${errorMessage ? 'visible' : 'invisible'}`}>
            {errorMessage}
          </p>
        </div>

        {inilineChild}
      </div>

    </div>
  );
};
